import type { DiagnosticContextPresentationLayerProps } from './diagnostic-context-presentation-layer.types';

export const DiagnosticContextPresentationLayer = ({
  children,
}: DiagnosticContextPresentationLayerProps) => children;
